import {
  NavBar,
  PdfSandSimulatorFile,
  SandSimSelector,
} from "../../components";
import { PdfPmmGuardianFile } from "../../components/pdf/files/PdfPmmGuardianFile";
import styles from "../main.module.sass";
import CancelIcon from "@mui/icons-material/Cancel";
import { useScreenshot } from "usescreenshot-react";
import PrintIcon from "@mui/icons-material/Print";
import { useRef, useState, useContext } from "react";
import { PDFView } from "../../components/pdf";
import SimulatorContext from "../../context/SimulatorContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const SandSimulator = () => {
  const [inPdf, setInPdf] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const { takeScreenshot } = useScreenshot();
  const ref = useRef<HTMLDivElement>(null);
  const {
    sandSimulatorValues,
    sandSimulatorResults,
    simulatorState,
    pmmGuardianValues,
    pmmGuardianResults,
    handleCancelSimulation,
  } = useContext(SimulatorContext);

  const buttons = [
    {
      title: "Cancel",
      action: handleCancelSimulation,
      icon: <CancelIcon />,
      disabled: false,
    },
    {
      title: inPdf ? "Return" : "Print",
      action: () => setInPdf(!inPdf),
      icon: inPdf ? <ArrowBackIcon /> : <PrintIcon />,
      disabled: false,
    },
  ];

  const getImage = () => {
    if (!ref.current) {
      return;
    }
    takeScreenshot(ref.current, {
      backgroundColor: null,
      logging: false,
    }).catch(console.log);
  };

  return (
    <>
      <NavBar title="Sand Simulation" buttons={buttons} />
      <div className={styles.simulatorPage}>
        {inPdf ? (
          activeTab === 3 ? (
            <PDFView
              document={() => (
                <PdfPmmGuardianFile
                  data={pmmGuardianValues}
                  results={pmmGuardianResults}
                />
              )}
            />
          ) : (
            <PDFView
              document={() => (
                <PdfSandSimulatorFile
                  data={sandSimulatorValues}
                  results={sandSimulatorResults}
                  simulator={simulatorState}
                />
              )}
            />
          )
        ) : (
          <>
            <SandSimSelector onTabChange={setActiveTab} />
          </>
        )}
      </div>
    </>
  );
};
